import React from "react";
import profile from "../images/profile.png";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import dayjs from "dayjs";

const TopCardPopUpExpiryList = ({
  showJobCardPopUp,
  closeJobCardModal,
  dataFromParent,
  list_name,
  onNavigateToEdit
}) => {
  const fetchProfilePic = (ImagePath) => {
    console.log("ImagePath:", ImagePath);
    if (!ImagePath) return profile;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    console.log(
      "image in explist",
      `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`,
    );
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  if (!showJobCardPopUp) return null;


    const handleRowClick = (empId) => {
    if (onNavigateToEdit) {
      onNavigateToEdit(empId);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
      <div className="relative bg-white w-full max-w-6xl rounded-lg shadow-lg p-4">
        {/* Header */}
        <div className="flex items-center justify-between border-b pb-2 mb-4">
          <h2 className="text-lg font-semibold text-gray-700">Expiry List</h2>
          <button
            onClick={closeJobCardModal}
            className="text-gray-500 hover:text-red-500 text-2xl"
          >
            &times;
          </button>
        </div>

        {/* Table Wrapper */}
        <div className="overflow-x-auto max-h-[80vh]">
          <table className="min-w-full text-sm text-left border border-gray-200">
            <thead className="bg-gray-100 text-gray-700 font-semibold">
              <tr>
                {list_name === "FLEETLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Reg No
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white text-center">
                      Name
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Type</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Ins type
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Days of Expiry
                    </th>
                  </>
                )}
                {list_name === "INSURANCEEXPLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">EmpId</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white text-center">
                      Days
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Name</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Job Title
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Insurance No
                    </th>
                  </>
                )}
                {list_name === "VISAEXPLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">EmpId</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white text-center">
                      Days
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Name</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Job Title
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Visa Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Visa No
                    </th>
                  </>
                )}
                {list_name === "NATIONALIDEXPLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">EmpId</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white text-center">
                      Days
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Name</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Job Title
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      ID Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">ID No</th>
                  </>
                )}
                {list_name === "PERSONIDEXPLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">EmpId</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white text-center">
                      Days
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Name</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Job Title
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      ID Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">ID No</th>
                  </>
                )}

                {list_name === "COMPANYDOCSEXPLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">DocId</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Name</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Days of Expiry
                    </th>
                  </>
                )}

                {list_name === "PASSPORTEXPLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">EmpId</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Days</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Name</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Job Title
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Passport No
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Issue Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Place of Issue
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Country of Issue
                    </th>
                  </>
                )}

                {list_name === "DRIVINGLICEXPLIST" && (
                  <>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Emp ID
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Days of Exp
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">Name</th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      Job Title
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      License Expiry Date
                    </th>
                    <th className="px-4 py-2 bg-[#2663EB] text-white">
                      License No
                    </th>
                  </>
                )}
              </tr>
            </thead>

            <tbody className="text-gray-800">
              {dataFromParent?.map((item, index) => (
                <tr key={index} onClick={() => handleRowClick(item.EmpId)}  className="hover:bg-gray-50">
                  {list_name === "INSURANCEEXPLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.EmpId}</td>
                      <td className="px-4 py-2 border text-center">
                        {item.Days_of_Exp}
                      </td>
                      <td className="px-4 py-2 border flex items-center gap-2">
                        <img
                          src={fetchProfilePic(item.imagepath)}
                          alt="profile"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        {item.Name}
                      </td>
                      <td className="px-4 py-2 border">{item.JobTitle}</td>
                      {/* <td className="px-4 py-2 border">{item.InsuranceExpiryDate}</td> */}
                      <td className="px-4 py-2 border">
                        {/* {item.InsuranceExpiryDate
                          ? new Date(
                              item.InsuranceExpiryDate,
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "N/A"} */}

                        {item.InsuranceExpiryDate &&
                          (() => {
                            const date = new Date(item.InsuranceExpiryDate);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>
                      <td className="px-4 py-2 border">{item.InsuranceNo}</td>
                    </>
                  )}
                  {list_name === "FLEETLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.Reg_No}</td>
                      <td className="px-4 py-2 border text-center">
                        {item.Name}
                      </td>
                      {/* <td className="px-4 py-2 border flex items-center gap-2">
                                                <img
                                                    src={fetchProfilePic(item.imagepath)}
                                                    alt="profile"
                                                    className="w-8 h-8 rounded-full object-cover"
                                                />
                                                {item.Name}
                                            </td> */}
                      <td className="px-4 py-2 border">{item.Type}</td>
                      <td className="px-4 py-2 border">{item.Ins_type}</td>
                      {/* <td className="px-4 py-2 border">{item.InsuranceExpiryDate}</td> */}
                      <td className="px-4 py-2 border">
                        {/* {item.Expiry
                          ? new Date(item.Expiry).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "N/A"} */}
                        {item.Expiry &&
                          (() => {
                            const date = new Date(item.Expiry);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>
                      <td className="px-4 py-2 border">{item.Days_of_Exp}</td>
                    </>
                  )}
                  {list_name === "VISAEXPLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.EmpId}</td>
                      <td className="px-4 py-2 border text-center">
                        {item.Days_of_Exp}
                      </td>
                      <td className="px-4 py-2 border flex items-center gap-2">
                        <img
                          src={fetchProfilePic(item.imagepath)}
                          alt="profile"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        {item.Name}
                      </td>
                      <td className="px-4 py-2 border">{item.JobTitle}</td>
                      <td className="px-4 py-2 border">
                        {/* {item.VisaExpiryDate
                          ? new Date(item.VisaExpiryDate).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              },
                            )
                          : "N/A"} */}
                        {item.VisaExpiryDate &&
                          (() => {
                            const date = new Date(item.VisaExpiryDate);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>{" "}
                      <td className="px-4 py-2 border">{item.VisaNo}</td>
                    </>
                  )}

                  {list_name === "NATIONALIDEXPLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.EmpId}</td>
                      <td className="px-4 py-2 border text-center">
                        {item.Days_of_Exp}
                      </td>
                      <td className="px-4 py-2 border flex items-center gap-2">
                        <img
                          src={fetchProfilePic(item.imagepath)}
                          alt="profile"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        {item.Name}
                      </td>
                      <td className="px-4 py-2 border">{item.JobTitle}</td>
                      <td className="px-4 py-2 border">
                        {/* {item.EmiratesIDExpiryDate
                          ? new Date(
                              item.EmiratesIDExpiryDate,
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : "N/A"} */}

                        {item.EmiratesIDExpiryDate &&
                          (() => {
                            const date = new Date(item.EmiratesIDExpiryDate);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>{" "}
                      <td className="px-4 py-2 border">{item.EmiratesID}</td>
                    </>
                  )}
                  {list_name === "PERSONIDEXPLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.EmpId}</td>
                      <td className="px-4 py-2 border text-center">
                        {item.Days_of_Exp}
                      </td>
                      <td className="px-4 py-2 border flex items-center gap-2">
                        <img
                          src={fetchProfilePic(item.imagepath)}
                          alt="profile"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        {item.Name}
                      </td>
                      <td className="px-4 py-2 border">{item.JobTitle}</td>
                      <td className="px-4 py-2 border">
                        {/* {item.Person_ID_Expiry
                          ? new Date(item.Person_ID_Expiry).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              },
                            )
                          : "N/A"} */}

                        {item.Person_ID_Expiry &&
                          (() => {
                            const date = new Date(item.Person_ID_Expiry);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>{" "}
                      <td className="px-4 py-2 border">{item.Person_ID}</td>
                    </>
                  )}

                  {list_name === "COMPANYDOCSEXPLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.docId}</td>
                      <td className="px-4 py-2 border">{item.Name}</td>
                      {/* <td className="px-4 py-2 border">{item.exp_date}</td> */}
                      <td className="px-4 py-2 border">
                        {item.exp_date &&
                          (() => {
                            const date = new Date(item.exp_date);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>{" "}
                      <td className="px-4 py-2 border">{item.Days_of_Exp}</td>
                    </>
                  )}

                  {list_name === "PASSPORTEXPLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.EmpId}</td>
                      <td className="px-4 py-2 border text-center">
                        {item.Days_of_Exp}
                      </td>
                      <td className="px-4 py-2 border flex items-center gap-2">
                        <img
                          src={fetchProfilePic(item.imagepath)}
                          alt="profile"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        {item.Name}
                      </td>

                      <td className="px-4 py-2 border">{item.JobTitle}</td>
                      <td className="px-4 py-2 border">
                        {/* {item.PassportExpiryDate &&
                          new Date(
                            item.PassportExpiryDate,
                          ).toLocaleDateString()} */}
                        {item.PassportExpiryDate &&
                          (() => {
                            const date = new Date(item.PassportExpiryDate);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>
                      <td className="px-4 py-2 border">{item.PassportNo}</td>
                      <td className="px-4 py-2 border">
                        {/* {item.PassportIssueDate &&
                          new Date(item.PassportIssueDate).toLocaleDateString()} */}

                        {item.PassportIssueDate &&
                          (() => {
                            const date = new Date(item.PassportIssueDate);

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>
                      <td className="px-4 py-2 border">
                        {item.PassportPlaceofIssue}
                      </td>
                      <td className="px-4 py-2 border">
                        {item.PassportCountryofIssue}
                      </td>
                    </>
                  )}

                  {list_name === "DRIVINGLICEXPLIST" && (
                    <>
                      <td className="px-4 py-2 border">{item.EmpId}</td>
                      <td className="px-4 py-2 border text-center">
                        {item.Days_of_Exp}
                      </td>
                      <td className="px-4 py-2 flex items-center gap-2">
                        <img
                          src={fetchProfilePic(item.imagepath)}
                          alt="profile"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        {item.Name}
                      </td>

                      <td className="px-4 py-2 border">{item.JobTitle}</td>
                      <td className="px-4 py-2 border">
                        {/* {item.PassportExpiryDate &&
                          new Date(
                            item.PassportExpiryDate,
                          ).toLocaleDateString()} */}
                        {item["Driving LicenseExpiry"] &&
                          (() => {
                            const date = new Date(
                              item["Driving LicenseExpiry"],
                            );

                            const day = date
                              .getDate()
                              .toString()
                              .padStart(2, "0");

                            const months = [
                              "Jan",
                              "Feb",
                              "Mar",
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                              "Oct",
                              "Nov",
                              "Dec",
                            ];

                            const month = months[date.getMonth()];
                            const year = date.getFullYear();

                            return `${day}-${month}-${year}`;
                          })()}
                      </td>
                      <td className="px-4 py-2 border">
                        {item["DrivingLicense No"]}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TopCardPopUpExpiryList;
